import { Button, Card, Col, Row } from "react-bootstrap";
import { useCart, stockLimit } from "../../contexts/Cart";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { t } from "i18next";
import localizedLink from "../../utils/localizedLink";
import productTitle from "../../utils/productTitle";
import useLanguage from "../../hooks/useLanguage";
import Price from "../../components/Price";
import { useTranslation } from "react-i18next";

export function cartCalculations(cartItems) {
    const totalQuantity = cartItems.reduce((total, item) => total + item.quantity, 0)
    const totalFullPrice = cartItems.reduce((total, item) => total + item.oldPrice * item.quantity, 0)
    const totalPrice = cartItems.reduce((total, item) => total + item.price * item.quantity, 0)
    let totalDiscount = cartItems.reduce((total, item) => total + (item.oldPrice - item.price) * item.quantity, 0)
    if (totalDiscount > 0) {
        totalDiscount = Math.round(totalDiscount * 100) / 100;
    }

    return {
        totalQuantity,
        totalFullPrice,
        totalPrice,
        totalDiscount
    }
}

export default function Cart() {
    const { cartItems, updateQuantity } = useCart();
    const { i18n } = useTranslation();
    const { language } = useLanguage();

    useEffect(() => {
        if (cartItems.length === 0) return

        try {
            window.fbq('track', 'InitiateCheckout',
                {
                    content_ids: ['partner_event_id'],
                    eventref: 'fb_oea'
                }
            );
        } catch (error) { }
    }, [])

    if (cartItems.length === 0) {
        return (
            <div className="mt-5 text-center">
                <h2 className="text-2xl font-medium">{t("cart.empty")}</h2>
                <Link to={localizedLink('/', language)} className="mt-3 btn btn-light">
                    {t("cart.home")}
                </Link>
            </div>
        );
    }

    const { totalQuantity, totalFullPrice, totalPrice, totalDiscount } = cartCalculations(cartItems);

    return (
        <div className="mt-5">
            <Row>
                <h2 className="text-2xl text-center mb-4">
                    {t("cart.checkout")}
                </h2>
                <Col lg={8} md={12} sm={12}>
                    {cartItems.map((product, key) => (
                        <Card className="eufy-card mb-3" key={product.id}>
                            <Card.Body className="d-flex">
                                <img
                                    src={product.imageUrl}
                                    loading="lazy"
                                    alt={productTitle(product, language)}
                                    className="w-25 h-25"
                                />
                                <div className="ml-3 d-flex justify-content-between align-items-center w-full">
                                    <div className="d-flex flex-column">
                                        <p className="text-lg"><Link to={`/${product.id}`}>{productTitle(product, language)}</Link></p>

                                        <Price product={product} size="sm" className="mt-2" />

                                        <div className="flex flex-row items-center w-max mt-3 rounded-full bg-white px-1">
                                            <button
                                                onClick={() => updateQuantity(product.id, product.quantity - 1)}
                                                className="flex items-center justify-center w-8 h-8 rounded-full text-[#1e2024] hover:bg-[#f5f6f7] transition-colors duration-200"
                                                aria-label="Decrease quantity"
                                            >
                                                <span className="text-2xl">-</span>
                                            </button>

                                            <div className="ml-4 mr-4 text-base flex items-center justify-center">
                                                {product.quantity}
                                            </div>

                                            <button
                                                onClick={() => updateQuantity(product.id, product.quantity + 1)}
                                                disabled={product.quantity >= stockLimit(product)}
                                                className="flex items-center justify-center w-8 h-8 rounded-full text-[#1e2024] hover:bg-[#f5f6f7] disabled:opacity-40 disabled:hover:bg-transparent transition-colors duration-200"
                                                aria-label="Increase quantity"
                                            >
                                                <span className="text-2xl">+</span>
                                            </button>
                                        </div>

                                        {product.quantity >= stockLimit(product) && (
                                            <p className="mt-2 text-sm text-red-800">
                                                {t("cart.stock-limit", { quantity: stockLimit(product) })}
                                            </p>
                                        )}
                                    </div>
                                    <div>

                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    ))}
                </Col>
                <Col>
                    <Card className="eufy-card mb-3">
                        <Card.Body className="d-flex flex-column text-base">
                            <p className="text-lg mb-3 font-bold">{t("cart.title")}</p>
                            <div className="text-sm d-flex justify-content-between align-items-center w-full">
                                <p>{t("cart.products")} <span className="text-sm">({totalQuantity})</span></p>
                                <p>{totalFullPrice} ₾</p>
                            </div>
                            <div className="text-sm d-flex justify-content-between align-items-center w-full">
                                <p>{t("cart.discount")}</p>
                                <p className="text-green-700">{totalDiscount === 0 ? `${totalDiscount}` : `-${totalDiscount}`} ₾</p>
                            </div>
                            <div className="text-sm d-flex justify-content-between align-items-center w-full">
                                <p>{t("cart.delivery")}</p>
                                <p>0 ₾</p>
                            </div>
                            <hr className="mt-3 mb-3" />
                            <div className="font-bold text-lg d-flex justify-content-between align-items-center w-full">
                                <p>{t("cart.total")}</p>
                                <p>{totalPrice} ₾</p>
                            </div>
                            <hr className="mt-3 mb-3" />
                            <Link to={localizedLink('/order', i18n.language)} className="d-flex flex-column"><Button variant="dark" className="eufy-button">{t("cart.checkout")}</Button></Link>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    );
}